import {logout, getInfo, loginByVerificationCode, loginByPassword} from '@/api/login'
import {getToken, setToken, removeToken} from '@/utils/auth'
import axios from "axios";
import i18n from "@/lang";
import {selectLinkShop} from "@/api/register";
import {removeWatermark, setWatermark} from "@/utils/watermarker";

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    userId: null,
    shelfId: null,
    shelfName: null,
    roleTypeList: [],
    phone: null,
    menus: [],
    localInfo: {},
    managerFlag: false,
    companyName: null,
    // 是否有自己的店铺
    shopFlag: false,
    // 关联的店铺申请标识 1.未发起 2.审批中 3.已驳回
    shopApplyFlag: false,
    email: '',
    shelfMode: null
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_USERID: (state, userId) => {
      state.userId = userId
    },
    SET_SHELFID: (state, shelfId) => {
      state.shelfId = shelfId
    },
    SET_SHELFNAME: (state, shelfName) => {
      state.shelfName = shelfName
    },
    SET_ROLETYPELIST: (state, roleTypeList) => {
      state.roleTypeList = roleTypeList
    },
    SET_PHONE: (state, phone) => {
      state.phone = phone
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus
    },
    SET_LOCALINFO: (state, localInfo) => {
      state.localInfo = localInfo
    },
    SET_MANAGERFLAG: (state, managerFlag) => {
      state.managerFlag = managerFlag
    },
    SET_COMPANYNAME: (state, companyName) => {
      state.companyName = companyName
    },
    SET_SHOPFLAG: (state, shopFlag) => {
      state.shopFlag = shopFlag
    },
    SET_SHOPAPPLYFLAG: (state, shopApplyFlag) => {
      state.shopApplyFlag = shopApplyFlag
    },
    SET_EMAIL: (state, email) => {
      state.email = email
    },
    SET_SHELFMODE: (state, shelfMode) => {
      state.shelfMode = shelfMode
    }
  },

  actions: {
    setToken({commit}, data) {
      commit('SET_TOKEN', data)
    },

    IsNeedEntry({commit}) {
      return new Promise((resolve, reject) => {
        selectLinkShop().then(response => {
          const data = response.data
          if (response.code === 200 && data) {
            commit('SET_SHOPFLAG', data.shopFlag)
            commit('SET_SHOPAPPLYFLAG', data.shopApplyFlag)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登录
    Login({commit}, userInfo) {
      return new Promise((resolve, reject) => {
        loginByPassword(userInfo).then(response => {
          const data = response.data
          if (response.code === 200 && data && data.tokenHead && data.token) {
            const tokenStr = data.tokenHead + data.token
            setToken(tokenStr)
            commit('SET_TOKEN', tokenStr)
            commit('SET_USERID', data.userId)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    verificationCodeLogin({commit}, phoneInfo) {
      return new Promise((resolve, reject) => {
        loginByVerificationCode(phoneInfo).then((res) => {
          if (res.code === 200) {
            let tokenStr = res.data.tokenHead + res.data.token
            setToken(tokenStr)
            commit('SET_TOKEN', tokenStr)
            commit('SET_USERID', res.data.userId)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })

    },

    // 获取用户信息
    GetInfo({commit, dispatch}) {
      return new Promise((resolve, reject) => {
        getInfo({token: getToken().split(' ')[1]}).then(response => {
          if (!response || !response.data || !response.data.permission) {
            throw new Error(i18n.t('system.noPermission'))
          }
          const data = response.data
          // if(!data.permission) return false
          const roleList = data.permission.roleIdList || []
          const menuList = data.permission.menus || []
          // 验证返回的roles是否是一个非空数组
          if (roleList && roleList.length && menuList && menuList.length) {
            commit('SET_USERID', data.id)
            localStorage.setItem('seller-userId', data.id)
            commit('SET_ROLES', roleList)
            commit('SET_NAME', data.username || data.email)
            commit('SET_EMAIL', data.email)
            // setWatermark('HURIX - ' + data.email)
            commit('SET_SHELFID', data.permission.shelfId)
            commit('SET_SHELFNAME', data.permission.shelfName)
            commit('SET_MANAGERFLAG', data.permission.managerFlag)
            commit('SET_COMPANYNAME', data.permission.shelfName)
            commit('SET_PHONE', data.phone)
            commit('SET_ROLETYPELIST', data.roleTypeList ? data.roleTypeList : [])
            commit("SET_SHELFMODE", data.permission.shopMode);
            commit('SET_MENUS', menuList)
            resolve(response)
          } else {
            // 自动执行登出操作
            dispatch('LogOut').then(() => {
              reject(i18n.t('system.noPermission'))
            }).catch(error => {
              reject(error)
            })
          }
        }).catch(error => {
          // 自动执行登出操作
          dispatch('LogOut').then(() => {
            reject(error)
          }).catch(error => {
            reject(error)
          })
        })
      })
    },

    // 获取用户的本地 IP
    GetLocalIP({commit, dispatch}) {
      return new Promise((resolve, reject) => {
        // 默认值GB
        const fallbackData = {
          country: 'GB',
          city: 'London'
        }
        // 设置请求超时时间（5秒）
        const timeout = 5000;
        const source = axios.CancelToken.source();
        const timeoutId = setTimeout(() => {
          source.cancel('Request timeout');
        }, timeout);

        axios.get('https://ipinfo.io/json', {
          cancelToken: source.token
        }).then(response => {
          clearTimeout(timeoutId);
          // 响应非200
          if (!response || response.status !== 200) {
            commit('SET_LOCALINFO', fallbackData);
            resolve(fallbackData);
            return;
          }

          const data = response.data
          // 验证响应数据是否有效
          if (!data || typeof data !== 'object') {
            console.log('Invalid response format from IP API');
            commit('SET_LOCALINFO', fallbackData);
            resolve(fallbackData);
            return;
          }
          // 确保国家代码存在，否则使用默认值GB
          const processedData = {
            ...data,
            country: data.country || 'GB',
            city: data.city || 'London'
          };
          commit('SET_LOCALINFO', processedData);
          resolve(processedData)
        }).catch(() => {
          clearTimeout(timeoutId);
          console.log(i18n.t('system.noIp'))
          commit('SET_LOCALINFO', fallbackData);
          resolve(fallbackData);
        });
      })
    },

    // 登出
    async LogOut({commit}, options = {}) {
      try {
        const token = getToken()
        if (token && !options.localOnly) {
          await logout({token: token.split(" ")[1]})
        }
      } catch (error) {
        // 服务端退出失败也要完成本地退出，让调用方继续跳转登录页。
      } finally {
        // removeWatermark()
        // 无论API成功与否，都执行清理
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        // commit('SET_NAME', '')
        commit('SET_AVATAR', '')
        commit('SET_USERID', null)
        commit('SET_SHELFID', null)
        commit('SET_PHONE', null)
        commit('SET_SHELFNAME', null)
        commit('SET_SHELFMODE', null)
        commit('SET_ROLETYPELIST', [])
        commit('SET_MENUS', [])
        sessionStorage.removeItem('bingCardPrompt')
        removeToken()
        localStorage.setItem('seller-userId', '')
      }
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js